import { gamesPopins } from "./games";
import { squadPopins } from "./squad";

export const popinLibraryFactory = (state, getters, rootState, rootGetters) => ({
  ...squadPopins(state, getters, rootState, rootGetters),
  ...gamesPopins(state, getters, rootState, rootGetters)
})
